/**
 * 订单流程节点增删 mixin：封装节点新增表单配置、选择弹窗、
 * 订单任务节点保存和节点删除前校验。
 */
export default {
  computed: {
    /**
     * 是否允许显示新增节点入口。
     */
    canShowNodeAdd: function () {
      return this.enableNodeAdd && !this.isReadonlyMode && !this.addBool
    },
    /**
     * 是否允许显示删除节点入口。
     */
    canShowNodeDelete: function () {
      return this.enableNodeAdd && !this.isReadonlyMode && !this.delBool
    },
    /**
     * 节点新增表单中实际展示的字段。
     */
    nodeAddVisibleColumns: function () {
      return (this.nodeAddColumns || []).filter(function (item) {
        return this.isNodeAddVisibleField(item)
      }.bind(this))
    }
  },
  methods: {
    /**
     * 将表单字段配置转换为弹窗表格列配置。
     */
    mapFormColumn: function (item, useKey2) {
      return {
        title: this.$translate.getColTitle(item, this.$store.state.lang),
        key: useKey2 ? String(item.key || '').toLowerCase() : item.key,
        key2: item.key,
        align: item.align,
        width: item.width,
        thide: item.THIDE,
        fhide: item.FHIDE,
        edcss: item.EDCSS,
        disabled: item.DISABLED,
        dotnum: item.DOTNUM,
        sortable: item.SORTABLE,
        notnull: item.NOTNULL
      }
    },
    /**
     * 判断字段是否在节点新增表单中展示。
     */
    isNodeAddVisibleField: function (item) {
      if (!item || item.fhide !== 'N') return false
      return item.key2 === 'WKNM' || item.key2 === 'REFIDTY'
    },
    /**
     * 获取节点新增字段标签，节点名称使用固定文案。
     */
    getNodeAddFieldLabel: function (item) {
      if (item && item.key2 === 'WKNM') return this.$LANG('', '节点名称')
      return this.$translate.getColTitle(item, this.$store.state.lang)
    },
    /**
     * 加载节点新增所需的字段、必填规则、下拉选项和选择弹窗列。
     */
    loadNodeAddSetup: function () {
      if (!this.enableNodeAdd) return Promise.resolve()
      // 复用同一表单配置接口，按 lstseq 加载不同选择窗口列。
      var loadColumns = function (lstseq, useKey2) {
        return this.loadTableRows('v_sys_form_fld', 'idseq', '17437', 'lstseq', String(lstseq), '', '', ' order by sortby,lstseq').then(function (rows) {
          return rows.map(function (item) { return this.mapFormColumn(item, useKey2) }.bind(this))
        }.bind(this))
      }.bind(this)
      // 节点新增表单必填规则。
      var loadRequired = this.loadTableRows('v_sys_form_fld', 'idseq', '17437', 'LSTSEQ', '3', 'NOTNULL', 'Y').then(function (rows) {
        var ruleObj = {}
        this.nodeAddRequiredFields = rows
        rows.forEach(function (item) {
          var fieldName = item.FLDNO === 'WKNM' ? this.$LANG('', '节点名称') : this.$translate.getColTitle(item, this.$store.state.lang)
          ruleObj[item.FLDNO] = [{ required: true, message: fieldName + this.$LANG('2051', '不能为空'), trigger: 'blur' }]
        }.bind(this))
        this.nodeAddValidate = ruleObj
      }.bind(this))
      // 节点新增表单 select 字段的字典选项。
      var loadCombos = this.loadTableRows('v_sys_form_fld', 'idseq', '17437', 'lstseq', '3', 'edcss', 'select').then(function (rows) {
        return Promise.all(rows.map(function (item) {
          return this.loadBaseRows({
            p_key: 'parentno',
            p_value: item.COMBO,
            p_table: 'v_sys_base'
          }).then(function (options) {
            return { key: item.FLDNO, options: options }
          })
        }.bind(this)))
      }.bind(this)).then(function (items) {
        var comboMap = {}
        items.forEach(function (item) {
          comboMap[item.key] = item.options
        })
        this.nodeAddComboArr = comboMap
      }.bind(this))
      // 工序类型字典。
      var loadWkty = this.loadBaseRows({
        p_key: 'PARENTNO',
        p_value: '461229',
        p_table: 'v_sys_base'
      }).then(function (rows) {
        this.nodeAddWktyArr = rows
      }.bind(this))
      return Promise.all([
        loadColumns(3, true).then(function (columns) { this.nodeAddColumns = columns }.bind(this)),
        loadColumns(2, false).then(function (columns) { this.nodeAddEmpColumns = columns }.bind(this)),
        loadColumns(9, false).then(function (columns) { this.nodeAddFormColumns = columns }.bind(this)),
        loadColumns(4, false).then(function (columns) { this.nodeAddItemColumns = columns }.bind(this)),
        this.loadTableRows('v_sys_form_fld', 'idseq', '108', 'lstseq', '1', '', '', ' order by sortby,lstseq').then(function (rows) {
          this.nodeAddPoColumns = rows.map(function (item) { return this.mapFormColumn(item, false) }.bind(this))
        }.bind(this)),
        this.loadTableRows('v_sys_form_fld', 'idseq', '123', 'lstseq', '1', '', '', ' order by sortby,lstseq').then(function (rows) {
          this.nodeAddOrdColumns = rows.map(function (item) { return this.mapFormColumn(item, false) }.bind(this))
        }.bind(this)),
        this.loadTableRows('v_sys_form_fld', 'idseq', '417247', 'lstseq', '1', '', '', ' order by sortby,lstseq').then(function (rows) {
          this.nodeAddNewColumns = rows.map(function (item) { return this.mapFormColumn(item, false) }.bind(this))
        }.bind(this)),
        loadRequired,
        loadCombos,
        loadWkty
      ]).catch(function (error) {
        this.showPrompt((error && error.message) || this.$LANG('1442', '提示'))
      }.bind(this))
    },
    /**
     * 重置节点新增弹窗和选择器的临时状态。
     */
    resetNodeAddState: function () {
      this.nodeAddWin = false
      this.nodeAddParent = null
      this.nodeAddMode = ''
      this.nodeAddSaving = false
      this.nodeAddForm = {}
      this.nodeAddSelectWin = false
      this.nodeAddMultiWin = false
      this.nodeAddSelectKey = ''
      this.nodeAddSelectColumns = []
      this.nodeAddSelectTable = ''
      this.nodeAddSelectKey2 = ''
      this.nodeAddSelectValue2 = ''
      this.nodeAddSelectCond = ''
    },
    /**
     * 获取当前 simple-mind-map 选中节点的数据。
     */
    getSelectedNodeData: function () {
      return (this.selectedNode && this.selectedNode.nodeData && this.selectedNode.nodeData.data) || null
    },
    /**
     * 判断节点是否已经落库为订单任务实例节点。
     */
    isPersistedOrderTaskNode: function (row) {
      row = row || {}
      if (row.id === 'root') return false
      var idseq = String(row.IDSEQ || '').trim()
      var code = String(row.CODE || '').trim()
      return !!idseq && !!code
    },
    /**
     * 从当前选中节点打开新增同级或子级节点弹窗。
     */
    openSelectedNodeAddDialog: function (mode) {
      if (!this.canShowNodeAdd) return
      var data = this.getSelectedNodeData()
      if (!data) {
        this.showPrompt(this.$LANG('', '请先选择节点'))
        return
      }
      if (mode === 'sibling' && data.id === 'root') {
        this.showPrompt(this.$LANG('', '根节点不能新增同级节点'))
        return
      }
      this.openNodeAddDialog(data, mode)
    },
    /**
     * 从当前选中节点发起删除流程。
     */
    deleteSelectedNode: function () {
      if (!this.canShowNodeDelete || this.nodeDeleteSaving) return
      var data = this.getSelectedNodeData()
      if (!data) {
        this.showPrompt(this.$LANG('', '请先选择节点'))
        return
      }
      if (data.id === 'root') {
        this.showPrompt(this.$LANG('', '根节点不能删除'))
        return
      }
      if (!this.isPersistedOrderTaskNode(data)) {
        this.showPrompt(this.$LANG('', '当前节点不是订单实例节点，不能删除'))
        return
      }
      var taskIdentity = this.getOrderTaskQueryIdentity()
      if (!taskIdentity.refIdseq || !taskIdentity.refLstseq) {
        this.showPrompt(this.$LANG('', '当前订单主键为空，不能删除节点'))
        return
      }
      this.checkOrderTaskNodeChildren(data).then(function (children) {
        if (children.length) {
          this.showPrompt(this.$LANG('0827', '已存在子节点，不能删除，若要删除，请先删除已存在的子节点'))
          return
        }
        this.confirmDeleteOrderTaskNode(data)
      }.bind(this)).catch(function (error) {
        this.showPrompt((error && error.message) || this.$LANG('1442', '提示'))
      }.bind(this))
    },
    /**
     * 删除前检查当前节点是否仍有子节点。
     */
    checkOrderTaskNodeChildren: function (row) {
      row = row || {}
      var parentCode = row.CODE || row.LSTSEQ || row.IDSEQ || ''
      if (!parentCode) return Promise.resolve([])
      var taskIdentity = this.getOrderTaskQueryIdentity()
      if (!taskIdentity.refIdseq || !taskIdentity.refLstseq) return Promise.resolve([])
      var cond = " and PARENTNO='" + this.escapeSqlValue(parentCode) + "'"
      return this.loadTableRows('V_ORD_TASKDTL', 'REFIDSEQ', taskIdentity.refIdseq, 'REFLSTSEQ', taskIdentity.refLstseq, '', '', cond).then(function (rows) {
        return this.filterUsableOrderTaskRows(this.dedupeOrderTaskRows(this.normalizeOrderTaskRows(rows)))
      }.bind(this))
    },
    /**
     * 打开节点删除确认框。
     */
    confirmDeleteOrderTaskNode: function (row) {
      this.$confirm(this.$LANG('1594', '你确定要删除此节点吗'), this.$LANG('1442', '提示'), {
        confirmButtonText: this.$LANG('1638', '确定'),
        cancelButtonText: this.$LANG('0132', '取消'),
        customClass: 'process-mind-map-message-box',
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'info'
      }).then(function () {
        return this.deleteOrderTaskNode(row)
      }.bind(this)).catch(function () {})
    },
    /**
     * 删除订单任务节点，并先删除该节点关联的 ORD_PROCESS 维护记录。
     */
    deleteOrderTaskNode: function (row) {
      if (this.nodeDeleteSaving) return
      var idseq = row && row.IDSEQ
      if (!idseq) {
        this.showPrompt(this.$LANG('', '当前节点缺少 IDSEQ，不能删除'))
        return
      }
      this.nodeDeleteSaving = true
      this.loadOrderProcessTableRowsForTask(row).then(function (processRows) {
        // 逐条串行删除维护记录，避免后端同时删除同表记录时互相覆盖。
        var chain = Promise.resolve()
        this.normalizeRows(processRows).forEach(function (item) {
          if (!item.IDSEQ) return
          chain = chain.then(function () {
            return this.deleteRecord('ORD_PROCESS', 'idseq', item.IDSEQ)
          }.bind(this))
        }.bind(this))
        return chain
      }.bind(this)).then(function () {
        return this.deleteRecord('ORD_TASKDTL', 'idseq', idseq)
      }.bind(this)).then(function () {
        this.selectedNode = null
        this.selectedNodeKey = ''
        this.fishboneDetailVisible = false
        this.fishboneDetailNode = null
        this.fishboneTaskRow = {}
        this.fishboneTaskAttachments = []
        this.fishboneLogList = []
        this.resetSourceStatusProbeState()
        return this.loadFishboneWorkDetails()
      }.bind(this)).catch(function (error) {
        this.showPrompt((error && error.message) || this.$LANG('1442', '提示'))
      }.bind(this)).finally(function () {
        this.nodeDeleteSaving = false
      }.bind(this))
    },
    /**
     * 打开节点新增弹窗，并根据新增模式计算父节点编码。
     */
    openNodeAddDialog: function (nodeData, mode, event) {
      if (mode && typeof mode !== 'string') {
        event = mode
        mode = ''
      }
      if (event && event.stopPropagation) event.stopPropagation()
      if (event && event.preventDefault) event.preventDefault()
      if (!this.canShowNodeAdd) return
      if (!this.nodeAddColumns.length) {
        this.loadNodeAddSetup().then(function () {
          this.openNodeAddDialog(nodeData, mode)
        }.bind(this))
        return
      }
      var data = nodeData || {}
      var addMode = data.id === 'root' ? 'child' : (mode || 'child')
      var parentNo = '#'
      if (data.id !== 'root' && addMode === 'child') parentNo = data.CODE || data.code || data.LSTSEQ || data.lstseq || ''
      if (data.id !== 'root' && addMode === 'sibling') parentNo = data.PARENTNO || data.parentno || '#'
      if (data.id !== 'root' && addMode === 'child' && !parentNo) {
        this.showPrompt(this.$LANG('1442', '提示') + '：' + this.$LANG('', '当前节点缺少 CODE，不能新增子节点'))
        return
      }
      var form = { PARENTNO: parentNo }
      this.nodeAddColumns.forEach(function (item) {
        if (item.key2 && form[item.key2] === undefined) form[item.key2] = ''
      })
      this.nodeAddParent = data
      this.nodeAddMode = addMode
      this.nodeAddForm = form
      this.nodeAddSelectKey = ''
      this.nodeAddWin = true
    },
    /**
     * 清空节点新增表单中带有关联关系的字段。
     */
    clearNodeAddField: function (field) {
      if (field === 'WKTY') {
        this.$set(this.nodeAddForm, 'ITEMTY', '')
        this.$set(this.nodeAddForm, 'SRC', '')
        this.$set(this.nodeAddForm, 'OUTPUT', '')
      } else if (field === 'REFIDTY') {
        this.$set(this.nodeAddForm, 'REFIDTY', '')
        this.$set(this.nodeAddForm, 'REFIDTYNM', '')
        this.$set(this.nodeAddForm, 'REFIDNO', '')
      }
    },
    /**
     * 打开来源单据类型多选窗口。
     */
    openNodeAddMultiSelect: function (field) {
      if (field !== 'REFIDTY') return
      this.nodeAddSelectColumns = this.nodeAddFormColumns
      this.nodeAddSelectTable = 'v_sys_form'
      this.nodeAddSelectKey2 = ''
      this.nodeAddSelectValue2 = ''
      this.nodeAddSelectCond = ' and frmurl is not null'
      this.nodeAddSelectRandom = Date.now()
      this.nodeAddMultiWin = true
    },
    /**
     * 回填来源单据类型多选结果。
     */
    handleNodeAddMultiSelected: function (rows) {
      rows = rows || []
      if (rows.length) {
        this.$set(this.nodeAddForm, 'REFIDTY', rows.map(function (item) { return item.FRMNM }).join(','))
        this.$set(this.nodeAddForm, 'REFIDTYNM', rows.map(function (item) { return item.IDSEQ }).join(','))
      }
      this.nodeAddMultiWin = false
    },
    /**
     * 根据字段类型打开员工、物料或来源单据编号选择窗口。
     */
    openNodeAddSelect: function (field) {
      this.nodeAddSelectKey = field
      this.nodeAddSelectCond = ''
      this.nodeAddSelectKey2 = ''
      this.nodeAddSelectValue2 = ''
      if (field === 'EMPNM' || field === 'EMPNM2') {
        this.nodeAddSelectColumns = this.nodeAddEmpColumns
        this.nodeAddSelectTable = 'v_HR_EMP'
        this.nodeAddSelectKey2 = 'STFG'
        this.nodeAddSelectValue2 = 'Y'
      } else if (field === 'ITEMTY') {
        this.nodeAddSelectColumns = this.nodeAddItemColumns
        this.nodeAddSelectTable = 'V_BS_LIBITM'
        this.nodeAddSelectKey2 = 'TYNM'
        this.nodeAddSelectValue2 = this.nodeAddForm.WKTY || ''
      } else if (field === 'REFIDNO') {
        if (this.nodeAddForm.REFIDTY === '采购订单') {
          this.nodeAddSelectColumns = this.nodeAddPoColumns
          this.nodeAddSelectTable = 'v_po_ord'
        } else if (this.nodeAddForm.REFIDTY === '销售订单') {
          this.nodeAddSelectColumns = this.nodeAddOrdColumns
          this.nodeAddSelectTable = 'v_ord'
        } else if (this.nodeAddForm.REFIDTY === '开发建议书') {
          this.nodeAddSelectColumns = this.nodeAddNewColumns
          this.nodeAddSelectTable = 'v_RD_MAT'
        } else {
          this.showPrompt(this.$LANG('', '当前来源类型暂未配置选择窗口'))
          return
        }
      } else {
        return
      }
      this.nodeAddSelectRandom = Date.now()
      this.nodeAddSelectWin = true
    },
    /**
     * 将单选窗口选择结果回填到节点新增表单。
     */
    handleNodeAddSelected: function (row) {
      row = row || {}
      if (this.nodeAddSelectKey === 'EMPNM2') {
        this.$set(this.nodeAddForm, 'EMPNM2', row.EMPNM || '')
        this.$set(this.nodeAddForm, 'EMPIDSEQ', row.IDSEQ || '')
      } else if (this.nodeAddSelectKey === 'EMPNM') {
        this.$set(this.nodeAddForm, 'EMPNM', row.EMPNM || '')
      } else if (this.nodeAddSelectKey === 'ITEMTY') {
        this.$set(this.nodeAddForm, 'ITEMTY', row.JOBNM || '')
        this.$set(this.nodeAddForm, 'SRC', row.SRC || '')
        this.$set(this.nodeAddForm, 'OUTPUT', row.OUTPUT || '')
      } else if (this.nodeAddSelectKey === 'REFIDNO') {
        this.$set(this.nodeAddForm, 'REFIDNO', row.IDNO || '')
      }
      this.nodeAddSelectWin = false
    },
    /**
     * 校验节点新增表单的必填项。
     */
    validateNodeAddForm: function () {
      var requiredMap = {}
      this.nodeAddRequiredFields.forEach(function (item) {
        requiredMap[item.FLDNO] = item
      })
      for (var i = 0; i < this.nodeAddVisibleColumns.length; i++) {
        var column = this.nodeAddVisibleColumns[i]
        var item = requiredMap[column.key2]
        if (item && !this.nodeAddForm[item.FLDNO]) {
          this.showPrompt((item.FLDNO === 'WKNM' ? this.$LANG('', '节点名称') : this.$translate.getColTitle(item, this.$store.state.lang)) + this.$LANG('2051', '不能为空'))
          return false
        }
      }
      return true
    },
    /**
     * 保存新增订单任务节点，保存后回写 code/task_idseq/task_lstseq 并刷新流程图。
     */
    handleNodeAddSave: function () {
      if (this.nodeAddSaving) return
      if (!this.validateNodeAddForm()) return
      var payload = Object.assign({}, this.nodeAddForm)
      payload.PARENTNO = payload.PARENTNO || '#'
      this.nodeAddSaving = true
      var orderPayload = this.buildOrderTaskPayload(payload, payload.PARENTNO, '', '')
      orderPayload.CODE = ''
      this.saveOrderTaskRow(orderPayload).then(function (savedRow) {
        var newId = this.getOrderTaskRowId(savedRow, savedRow.IDSEQ)
        if (!newId) throw new Error(this.$LANG('1442', '提示') + '：' + this.$LANG('', '新增订单实例节点未返回主键'))
        return this.updateOrderTaskRow(newId, [
          { key: 'code', value: String(newId) },
          { key: 'task_idseq', value: this.normalizeNumberValue(newId) },
          { key: 'task_lstseq', value: this.normalizeNumberValue(newId) }
        ]).then(function () {
          return newId
        })
      }.bind(this)).then(function (newId) {
        this.selectedNodeKey = String(newId)
        this.nodeAddWin = false
        this.resetSourceStatusProbeState()
        return this.loadFishboneWorkDetails()
      }.bind(this)).catch(function (error) {
        this.showPrompt((error && error.message) || this.$LANG('1442', '提示'))
      }.bind(this)).finally(function () {
        this.nodeAddSaving = false
      }.bind(this))
    }
  }
}
